import { FormControl, Validators } from '@angular/forms';

export class OwnerFindingForm {
  constructor() {}

  id = new FormControl<number | undefined>(
    { value: undefined, disabled: false },
    { nonNullable: true }
  );
  OwnerId = new FormControl<number | undefined>(
    { value: undefined, disabled: false },
    { nonNullable: true, validators: [Validators.required] }
  );
  VendorId = new FormControl<number | undefined>(
    { value: undefined, disabled: false },
    { nonNullable: true, validators: [Validators.required] }
  );
  ownerIdentity = new FormControl<number | null>(null);
  ownerWatchlist = new FormControl<number | null>(null);
  ownerFelony = new FormControl<number | null>(null);
  ownerMisdemeanor = new FormControl<number | null>(null);
  ownerBankruptcy = new FormControl<number | null>(null);
  ownerLiens = new FormControl<number | null>(null);
  ownerSexOffender = new FormControl<boolean | null>(null);
  updatedAt = new FormControl<undefined | Date>(
    { value: undefined, disabled: false },
    { nonNullable: true }
  );
}
